import { clamp } from '../../utils'
import { Level } from './level'

export class Playlist {
  levels = []
  _currentLevelIndex = 0
  _keyMap = Object.create(null) // { url: Unit8Array }
  _dvrWindow = 0

  _segmentPointer = 0

  get lastSegment () {
    return this.currentLevel?.lastSegment
  }

  get currentLevel () {
    return this.levels[this._currentLevelIndex]
  }

  get prevSegment () {
    return this.currentSegments?.[this._segmentPointer - 1]
  }

  get currentSegment () {
    return this.currentSegments?.[this._segmentPointer]
  }

  get currentSegments () {
    return this.currentLevel?.segments
  }

  get liveEdge () {
    return this.currentLevel?.liveEdge
  }

  get seekRange () {
    const segments = this.currentSegments
    if (!segments || !segments.length) return
    return [
      segments[0].start,
      segments[segments.length - 1].end
    ]
  }

  moveSegmentPointer (pos) {
    if (pos == null) pos = this._segmentPointer + 1
    this._segmentPointer = clamp(pos, 0, this.currentSegments?.length)
  }

  reset () {
    this.levels = []
    this._keyMap = Object.create(null)
    this._currentLevelIndex = 0
    this._dvrWindow = 0
    this._segmentPointer = 0
  }

  getKey (keyUrl) {
    if (keyUrl) return this._keyMap[keyUrl]
    return Object.values(this._keyMap)[0]
  }

  setKey (keyUrl, key) {
    this._keyMap[keyUrl] = key
  }

  getSegmentByIndex (index) {
    return this.currentSegments?.[index]
  }

  findSegmentIndexByTime (time) {
    const segments = this.currentSegments
    if (segments) {
      for (let i = 0, l = segments.length, seg; i < l; i++) {
        seg = segments[i]
        if (time >= seg.start && time < seg.end) {
          return i
        }
      }

      const lastSegment = segments[segments.length - 1]
      if (Math.abs(time - lastSegment.end) < 0.2) return segments.length - 1
    }
  }

  upsertPlaylist (playlist) {
    if (!playlist) return
    if (Array.isArray(playlist.streams)) {
      this.levels.length = playlist.streams.length
      playlist.streams.filter(x => x.url).forEach((stream, i) => {
        if (this.levels[i]) {
          this.levels[i].update(stream)
        } else {
          this.levels[i] = new Level(stream)
        }
      })
    } else if (Array.isArray(playlist.segments)) {
      const level = this.currentLevel
      if (level) {
        level.update(playlist)
      } else {
        this.reset()
        this.levels[0] = new Level(playlist)
      }
    }

    const currentLevel = this.currentLevel

    if (currentLevel) {
      if (currentLevel.live && !this._dvrWindow) {
        this._dvrWindow = this.currentSegments.reduce((a, c) => {
          a += c.duration
          return a
        }, 0)
      }
    }
  }

  clearOldSegment () {
    const level = this.currentLevel
    if (!this._dvrWindow || !level) return
    const startTime = level.endTime - this._dvrWindow
    if (startTime <= 0) return

    let sliceStart = 0
    const segments = level.segments
    for (let i = 0, l = segments.length; i < l; i++) {
      if (segments[i].end >= startTime) {
        sliceStart = i
        break
      }
    }
    if (sliceStart > this._segmentPointer) {
      sliceStart = this._segmentPointer
    }

    level.segments = level.segments.slice(sliceStart)
    this._segmentPointer -= sliceStart
  }

  inDvrWindow (currentTime, dvrWindow = this._dvrWindow) {
    const level = this.currentLevel
    if (!level || (dvrWindow == null)) return false
    return currentTime < level.endTime && currentTime > level.endTime - dvrWindow
  }
}
